<template>
  <div :class="['ring-content', { 'ring-wrap-before': showRingLottie }]">
    <div id="ring-type" class="type">
      <div class="text-horizen text-top" :style="{ opacity: textOpacity.roused }">
        {{ $t('personality-custom-ring-type-top') }}
      </div>
      <div class="text-vertical text-right" :style="{ opacity: textOpacity.enrich }">
        {{ $t('personality-custom-ring-type-right') }}
      </div>
      <div class="text-horizen text-btm" :style="{ opacity: textOpacity.calm }">
        {{ $t('personality-custom-ring-type-bottom') }}
      </div>
      <div class="text-vertical text-left" :style="{ opacity: textOpacity.simple }">
        {{ $t('personality-custom-ring-type-left') }}
      </div>
      <div class="line-v"></div>
      <div class="line-h"></div>
      <div
        v-show="!showRingLottie"
        ref="cursor"
        :class="['cursor', { 'cursor-dragging': dragging }]"
        :style="{ left: cursorLeft + 'px', top: cursorTop + 'px' }"
        @touchstart="handleCursorStart"
        @mousedown="handleCursorStart"
      ></div>
      <div
        v-if="showRingLottie"
        ref="ringTypeLottie"
        data-bm-renderer="svg"
        class="lottie"
        @click="handleLottieClick"
      ></div>
    </div>
    <div class="ring-speed">
      <span :style="{ opacity: textOpacity.slow }">{{ $t('personality-custom-ring-speed-slow') }}</span>
      <span :style="{ opacity: textOpacity.fast }">{{ $t('personality-custom-ring-speed-fast') }}</span>
      <div class="line-v"></div>
      <div
        v-show="!showRingLottie"
        ref="speed"
        :class="['line-cursor', { 'line-cursor-dragging': speedDragging }]"
        :style="{ left: speedLeft + 'px' }"
        @touchstart="handleCursorStart"
        @mousedown="handleCursorStart"
      ></div>
      <div
        v-if="showRingLottieSpeed && !isMovedSpeed"
        ref="ringSpeedLottie"
        data-bm-renderer="svg"
        class="lottie"
        @click="showRingLottieSpeed = false"
      ></div>
    </div>
    <div class="overlay enrich" :style="{ opacity: opacity.enrich }"></div>
    <div class="overlay calm" :style="{ opacity: opacity.calm }"></div>
    <div class="overlay roused" :style="{ opacity: opacity.roused }"></div>
    <div class="overlay simple" :style="{ opacity: opacity.simple }"></div>
    <!-- 加载 正常 音频文件 -->
    <lazy-component @show="getAudioDoms(1)">
      <div class="audio-wrap1">
        <audio v-for="i in 5" :key="i" loop :src="require(`../../assets/personality/voice/0${i}-02.mp3`)"></audio>
      </div>
    </lazy-component>
    <template v-if="!showRingLottie">
      <div v-for="n in [1, 3]" :key="n">
        <div :class="'audio-wrap' + (n - 1)">
          <audio v-for="i in 5" :key="i" loop :src="require(`../../assets/personality/voice/0${i}-0${n}.mp3`)"></audio>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import lottie from 'lottie-web/build/player/lottie_svg.min';
export default {
  inject: ['vm'],
  data() {
    return {
      showRingLottie: true,
      showRingLottieSpeed: false,
      isMovedSpeed: false,
      dragging: false,
      cursorLeft: 185,
      cursorTop: 190,
      speedDragging: false,
      voiceType: 5,
      speedLeft: 207,
      speedType: 2, //速度类型1：慢2：正常3：快
      textOpacity: {
        enrich: 0.2,
        calm: 0.2,
        roused: 0.2,
        simple: 0.2,
        slow: 0.2,
        fast: 0.2
      },
      opacity: {
        enrich: 0,
        calm: 0,
        roused: 0,
        simple: 0
      },
      audioDoms: []
    };
  },
  watch: {
    voiceType(newValue, oldValue) {
      // 先暂停当前音乐再播放新音乐
      this.audioDoms[this.speedType - 1][oldValue - 1].pause();
      this.audioDoms[this.speedType - 1][newValue - 1].play();
    },
    speedType(newValue, oldValue) {
      this.audioDoms[oldValue - 1][this.voiceType - 1].pause();
      this.audioDoms[newValue - 1][this.voiceType - 1].play();
    },
    showRingLottie(newVal, oldVal) {
      if (oldVal) {
        this.$nextTick(() => {
          [0, 2].forEach(pos => this.getAudioDoms(pos));
        });
      }
    }
  },
  mounted() {
    if (location.href.indexOf('localhost:800') > -1) return;
    import(`./js/custom-ring-type${this.vm.lang === 'zh' ? '-zh' : ''}.json`).then(animationData => {
      // get from https://github.com/facebook/jest/issues/7271 and jianshu.com/p/78f7b19932cb
      animationData.assets[0].u = '';
      animationData.assets[0].p = require('./js/lottie-img/img_type.png');
      this.ringTypeLottieAnimation = lottie.loadAnimation({
        container: this.$refs.ringTypeLottie,
        renderer: 'svg',
        loop: true,
        autoplay: false,
        animationData
      });
    });
  },
  methods: {
    handleLottieClick() {
      this.showRingLottie = false;
      this.$nextTick(() => {
        this.initCursorPosition();
      });
    },
    initCursorPosition() {
      let cursorDome = this.$refs.cursor;
      let speedDom = this.$refs.speed;
      //获取声音类型区域的样式
      this.wrapDomRect = document.querySelector('#ring-type').getBoundingClientRect();
      this.cursorDomeRect = cursorDome.getBoundingClientRect();
      // 获取速度区域的样式
      this.speedWrapDomRect = document.querySelector('.ring-speed').getBoundingClientRect();
      this.speedDomeRect = speedDom.getBoundingClientRect();
      // 计算光标的基础位置
      this.cursorLeft = this.wrapDomRect.width / 2 - this.cursorDomeRect.width / 2;
      this.cursorTop = this.wrapDomRect.height / 2 - this.cursorDomeRect.height / 2;
      // 计算速度光标的基础位置
      this.speedLeft = this.speedWrapDomRect.width / 2 - this.speedDomeRect.width / 2;
    },
    handlePlayVoice() {
      // 中心区域正方形宽高
      let centerLength = 150;
      //水平进入中心区域的值
      let leftLimit = (this.leftMax - this.leftMin - centerLength) / 2;
      let rightLimit = leftLimit + centerLength;
      // 垂直进入中心区域的值
      let topLimit = (this.topMax - this.topMin - centerLength) / 2;
      let bottomLimit = topLimit + centerLength;
      //滚动区域的中间区间线
      let vertivalMiddle = this.topMax / 2;
      let horizenCenter = this.leftMax / 2;
      //速度区间
      let speedLeftLimit = (this.speedLeftMax - this.speedLeftMin) / 3 + 30;
      let speedRightLimit = speedLeftLimit * 2;
      //判断音乐类型
      if (this.cursorLeft < leftLimit) {
        this.voiceType = this.cursorTop > vertivalMiddle ? 1 : 2;
      } else if (this.cursorLeft > rightLimit) {
        this.voiceType = this.cursorTop > vertivalMiddle ? 3 : 4;
      } else if (this.cursorTop < topLimit) {
        this.voiceType = this.cursorLeft > horizenCenter ? 4 : 2;
      } else if (this.cursorLeft > bottomLimit) {
        this.voiceType = this.cursorLeft > horizenCenter ? 3 : 1;
      } else {
        this.voiceType = 5;
      }
      // 判断速度类型
      if (this.speedLeft < speedLeftLimit) {
        this.speedType = 1;
      } else if (this.speedLeft > speedRightLimit) {
        this.speedType = 3;
      } else {
        this.speedType = 2;
      }
    },
    handleCursorStart(e) {
      let cursorDome = this.$refs.cursor;
      let speedDom = this.$refs.speed;
      if (e.target === cursorDome) {
        //播放速度lottie
        if (!this.showRingLottieSpeed) {
          this.showRingLottieSpeed = true;
          this.$nextTick(() => {
            import(`./js/custom-ring-speed${this.vm.lang === 'zh' ? '-zh' : ''}.json`).then(animationData => {
              // get from https://github.com/facebook/jest/issues/7271 and jianshu.com/p/78f7b19932cb
              animationData.assets[0].u = '';
              animationData.assets[0].p = require('./js/lottie-img/img_speed.png');
              this.ringSpeedLottieAnimation = lottie.loadAnimation({
                container: this.$refs.ringSpeedLottie,
                renderer: 'svg',
                loop: true,
                autoplay: true,
                animationData
              });
            });
          });
        }
        this.dragging = true;
        this.topMin = 0;
        this.leftMin = 22;
        this.$nextTick(() => {
          this.cursorDomeDraggingRect = cursorDome.getBoundingClientRect();
          this.leftMax = this.wrapDomRect.width - this.cursorDomeDraggingRect.width;
          this.topMax = this.wrapDomRect.height - this.cursorDomeDraggingRect.height;
        });
        // 一旦点击就开始播放音乐
        this.audioDoms[this.speedType - 1][this.voiceType - 1].play();
      } else if (e.target == speedDom) {
        this.isMovedSpeed = true;
        this.speedDragging = true;
        this.speedLeftMin = 40;
        this.$nextTick(() => {
          this.speedDomeDraggingRect = speedDom.getBoundingClientRect();
          this.speedLeftMax = this.speedWrapDomRect.width - this.speedDomeDraggingRect.width - 30;
        });
      }
      !this.lisetnerAdded && this.handleEventLisetner();
    },
    handleEventLisetner() {
      let wrapDom = document.querySelector('.personality-custom');
      if (this.vm.isMobile) {
        wrapDom.addEventListener('touchmove', this.handleCursorMouseMove, false);
        wrapDom.addEventListener('touchend', this.handleCursorMouseUp, false);
      } else {
        wrapDom.addEventListener('mousemove', this.handleCursorMouseMove, false);
        wrapDom.addEventListener('mouseup', this.handleCursorMouseUp, false);
      }
      this.lisetnerAdded = true;
    },
    handleRemoveLisetner() {
      let wrapDom = document.querySelector('.personality-custom');
      if (this.vm.isMobile) {
        wrapDom.removeEventListener('touchmove', this.handleCursorMouseMove, false);
        wrapDom.removeEventListener('touchend', this.handleCursorMouseUp, false);
      } else {
        wrapDom.removeEventListener('mousemove', this.handleCursorMouseMove, false);
        wrapDom.removeEventListener('mouseup', this.handleCursorMouseUp, false);
      }
      this.lisetnerAdded = false;
    },
    moveCursor(e) {
      let left = (e.clientX || e.touches[0].clientX) - this.wrapDomRect.left - 30;
      let top = (e.clientY || e.touches[0].clientY) - this.wrapDomRect.top - 30;
      if (left < this.leftMin) left = 0;
      if (left > this.leftMax) left = this.leftMax;
      if (top < this.topMin) top = this.topMin;
      if (top > this.topMax) top = this.topMax;
      this.cursorLeft = left;
      this.cursorTop = top;
      this.computingOpacity(top, left);
    },
    handleCursorMouseMove(e) {
      if (this.dragging) {
        this.moveCursor(e);
      }
      if (this.speedDragging) {
        let left = (e.clientX || e.touches[0].clientX) - this.speedWrapDomRect.left;
        if (left < this.speedLeftMin) left = this.speedLeftMin;
        if (left > this.speedLeftMax) left = this.speedLeftMax;
        this.speedLeft = left;
        this.computingSpeedOpacity(left, this.speedLeftMax);
      }
      this.handlePlayVoice();
    },
    handleCursorMouseUp() {
      this.dragging = false;
      this.speedDragging = false;
      this.handleRemoveLisetner();
    },
    computingSpeedOpacity(left, leftMax) {
      let width = this.speedWrapDomRect.width;
      let delta = 0.8;
      if (left < width / 2) {
        this.textOpacity.fast = 0.2;
        this.textOpacity.slow = 0.2 + (1 - (left - 40) / (width / 2 - 40)) * delta;
      } else {
        this.textOpacity.slow = 0.2;
        this.textOpacity.fast = 0.2 + (left / leftMax) * delta;
      }
      // console.log(width, leftMax, left, 1 - (left * 2) / width);
    },
    computingOpacity(top, left) {
      let { width, height } = this.wrapDomRect;
      let baseOpacity = 0;
      let baseTextOpacity = 0.2;
      let deltaBaseTextOpacity = 0.1; //最远字体颜色为0.1 =>变量为0.1
      let deltaOpatity = 0.8,
        deltaTextOpacity = 0.3;

      if (left > width / 2) {
        let progress = (left + this.cursorDomeDraggingRect.width) / width;
        this.opacity.simple = 0;
        this.opacity.enrich = progress * deltaOpatity + baseOpacity;
        this.textOpacity.simple = baseTextOpacity - deltaBaseTextOpacity * progress;
        this.textOpacity.enrich = baseTextOpacity + progress * deltaTextOpacity;
      } else {
        let progress = 1 - (2 * left) / width;
        this.opacity.enrich = 0;
        this.opacity.simple = progress * deltaOpatity + baseOpacity;
        this.textOpacity.enrich = baseTextOpacity - deltaBaseTextOpacity * progress;
        this.textOpacity.simple = baseTextOpacity + progress * deltaTextOpacity;
      }
      if (top > height / 2) {
        let progress = (top + this.cursorDomeDraggingRect.height) / height;
        this.opacity.roused = 0;
        this.opacity.calm = progress * deltaOpatity + baseOpacity;
        this.textOpacity.roused = baseTextOpacity - deltaBaseTextOpacity * progress;
        this.textOpacity.calm = baseTextOpacity + progress * deltaTextOpacity;
      } else {
        let progress = 1 - (2 * top) / height;
        this.opacity.calm = 0;
        this.opacity.roused = progress * deltaOpatity + baseOpacity;
        this.textOpacity.calm = baseTextOpacity - deltaBaseTextOpacity * progress;
        this.textOpacity.roused = baseTextOpacity + progress * deltaTextOpacity;
      }
    },
    //获取音乐文件的dom节点用于播放暂停操作
    getAudioDoms(pos) {
      setTimeout(() => {
        if (this.audioDoms[pos]) return;
        this.audioDoms[pos] = Array.from(document.querySelector('.audio-wrap' + pos).children);
        console.log(this.audioDoms);
      }, 300);
    },
    pauseCurrentVoice() {
      this.audioDoms.length > 0 && this.audioDoms[this.speedType - 1][this.voiceType - 1].pause();
    },
    playCurrentVoice() {
      !this.showRingLottie &&
        this.audioDoms.length > 0 &&
        this.audioDoms[this.speedType - 1][this.voiceType - 1].play();
    },
    playLottie() {
      if (this.showRingLottie) {
        this.ringTypeLottieAnimation && this.ringTypeLottieAnimation.play();
        return;
      }
      this.showRingLottieSpeed && !this.isMovedSpeed && this.ringSpeedLottieAnimation.play();
    },
    stopLottie() {
      if (this.showRingLottie) {
        this.ringTypeLottieAnimation && this.ringTypeLottieAnimation.stop();
        return;
      }
      this.showRingLottieSpeed && !this.isMovedSpeed && this.ringSpeedLottieAnimation.stop();
    }
  }
};
</script>

<style lang="scss" scoped>
$dashedLineColor: rgba(
  $color: #fff,
  $alpha: 0.2
);
.ring-content {
  position: relative;
  width: 414px;
  margin: 0 auto;
  height: 640px;
  .type {
    height: 500px;
    position: relative;
    .text-top,
    .text-right,
    .text-btm,
    .text-left {
      position: absolute;
      color: #fff;
      font-size: 36px;
      pointer-events: none;
      user-select: none;
      font-variation-settings: 'wght' 1000;
    }
    .text-vertical {
      width: 37px;
      top: 50%;
      transform: translateY(-50%);
    }
    .text-horizen {
      left: 50%;
      transform: translateX(-50%);
    }
    .text-top {
      top: 28px;
    }
    .text-btm {
      bottom: 38px;
    }
    .text-right {
      right: 22px;
      writing-mode: vertical-lr;
    }
    .text-left {
      left: 22px;
      writing-mode: vertical-rl;
    }
    .line-v {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translateY(-50%);
      width: 0px;
      height: 115px;
      border-left: 1px dashed $dashedLineColor;
    }
    .line-h {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translateX(-50%);
      width: 115px;
      height: 0px;
      border-top: 1px dashed $dashedLineColor;
    }
    .cursor {
      position: absolute;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      border: 2px solid #fff;
      z-index: 10;
      transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1), height 0.3s cubic-bezier(0.4, 0, 0.2, 1),
        border-radius 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    }
    .cursor-dragging {
      width: 60px;
      height: 60px;
      border: 6px solid #fff;
      transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1), height 0.3s cubic-bezier(0.4, 0, 0.2, 1),
        border-radius 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    }
  }
  .ring-speed {
    position: relative;
    height: 140px;
    border-top: 1px dashed $dashedLineColor;
    padding: 0 22px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 36px;
    font-variation-settings: 'wght' 1000;
    color: #fff;
    .line-v {
      position: absolute;
      left: 50%;
      top: 0;
      height: 140px;
      border-left: 1px dashed $dashedLineColor;
    }
    .line-cursor {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 5px;
      height: 40px;
      border-radius: 28px;
      background: #fff;
      transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1), height 0.3s cubic-bezier(0.4, 0, 0.2, 1),
        border-radius 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    }
    .line-cursor-dragging {
      width: 10px;
      height: 80px;
      border-radius: 28px;
      background: #fff;
      transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1), height 0.3s cubic-bezier(0.4, 0, 0.2, 1),
        border-radius 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    }
    .lottie {
      top: -64px;
      pointer-events: none;
    }
  }
  .overlay {
    position: absolute;
    left: 0;
    bottom: 2px;
    width: 100%;
    height: 912px;
    pointer-events: none;
    mix-blend-mode: overlay;
    border-radius: 13px;
  }
  .enrich {
    background: #ac522c;
  }
  .calm {
    background: #12d879;
  }
  .roused {
    background: #c6315d;
  }
  .simple {
    background: #0075ff;
  }
}
.audio-wrap {
  position: absolute;
  top: 0;
  left: 0;
}
.lottie {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 15;
}
.ring-wrap-before {
  &::after {
    content: ' ';
    position: absolute;
    width: 416px;
    height: 911px;
    left: 50%;
    bottom: 2px;
    margin-left: -208px;
    background: rgba($color: #000000, $alpha: 0.7);
    border-radius: 10px;
    z-index: 10;
  }
}
</style>
